import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import listAnalytics from './listAnalytics';
import Button from '../../components/Elements/Button/Button';
import { updatePagination } from '../../actions/environment';
import { difference, arraysEqual } from '../../utils/array';
import { addEvent, removeEvent, offset, height } from '../../utils/dom';
import { urlify, translate } from '../../utils/string';
import s from './Pagination.scss';

class Pagination extends Component {
	constructor(props) {
		super(props);

		this.itemsSeen = [];
		this.indexes = {};
		this.itemsSent = [];
		this.paginationContainer = React.createRef();
	}

	componentDidMount() {
		let debounced = false;

		addEvent(window, 'scroll.pagination', () => {
			window.requestAnimationFrame(() => {
				if (!debounced && this.paginationContainer.current) {
					const paginationTop = offset(this.paginationContainer.current);
					const paginationHeight = height(this.paginationContainer.current);

					// Loads in when one window away.
					if (window.pageYOffset + (height(window) * 2) > paginationTop.top + paginationHeight) {
						this.handleLoadMore(true);
						debounced = true;
						window.setTimeout(() => {
							debounced = false;
						}, 500);
					}
				}
			});
		});

		this.handleListAnalytics();
	}

	componentDidUpdate(prevProps) {
		if (!arraysEqual(this.props.list, prevProps.list)) {
			this.handleListAnalytics();
		}
	}

	componentWillUnmount() {
		removeEvent(window, 'scroll.pagination');
	}

	handleListAnalytics = () => {
		if (this.paginationContainer.current !== null) {
			const options = {
				root: null,
				rootMargin: '0px',
				threshold: [0.5],
			};

			const handleIntersect = (elements) => {
				elements.forEach((el) => {
					if (el.isIntersecting) {
						const id = el.target.dataset.productId;
						this.indexes[id] = el.target.dataset.productIndex;
						if (this.itemsSeen.indexOf(id) === -1) this.itemsSeen.push(id);
					}
				});
				const itemsToSend = difference(this.itemsSeen, this.itemsSent);
				if (itemsToSend.length > 0) {
					listAnalytics(itemsToSend.map((i) => this.props.cache[i]), itemsToSend.map((i) => this.indexes[i]), this.props.setup, this.props.currentPath || 'productPicker');
					this.itemsSent = [...this.itemsSent, ...itemsToSend];
				}
			};

			const observer = new window.IntersectionObserver(handleIntersect, options);
			this.paginationContainer.current.querySelectorAll('.u_productItem').forEach((e) => observer.observe(e));
		}
	}

	handleLoadMore = (automatic = false) => {
		const { pagination, list, cache, currentPath, paging = false, paginationLoader = false, limit = this.props.setup.statics.productLimit } = this.props;
		const currentPage = pagination[currentPath] || 1;
		const pageBase = list || cache;
		const maxPages = paging ? Math.ceil(paging.total / paging.limit) : Math.ceil(pageBase.length / limit);

		if ((automatic !== true && currentPage === 3 && currentPage < maxPages) || (currentPage !== 3 && currentPage < maxPages)) {
			// 3rd page human must click button
			this.props.updatePagination(currentPath, currentPage + 1);
			if (paginationLoader !== false) paginationLoader(currentPage + 1);
		}
	}

	render() {
		const {
			ListComponent,
			pagination,
			setup,
			list,
			cache,
			currentPath,
			showAll = false,
			paging = null,
			currentHash = '',
			canonical = false,
			magazine = false,
			limit = this.props.setup.statics.productLimit,
		} = this.props;

		const currentPage = pagination[currentPath] || 1;
		const pageBase = list || cache;
		const listPart = showAll ? pageBase : pageBase.slice(0, currentPage * limit);
		const maxPages = paging ? Math.ceil(paging.total / paging.limit) : Math.ceil(pageBase.length / limit);

		return (
			<div className={pageBase.length < 4 ? s.paginationContainer__centered : null} ref={this.paginationContainer}>
				{
					listPart.map((item, i) => {
						let id;
						if (list) {
							id = item;
							item = cache[item];
						}
						return item ? <ListComponent key={list ? id : urlify(translate(setup, item.uri))} id={id} content={item} canonical={magazine ? translate(setup, item.uri) : canonical} setup={setup} currentPath={currentPath} currentHash={currentHash} currentView={currentPath || 'productPicker'} index={i} /> : null;
					})
				}
				{
					currentPage < maxPages && !showAll ? (
						<div className={s.pagination}>
							<Button clickEventHandler={this.handleLoadMore} text={translate(setup, 'loadMore')} />
						</div>
					) : null
				}
			</div>
		);
	}
}

const mapState = ({ environment }, { ListComponent, list, cache, currentPath, showAll = false, paging = null, currentHash = '', canonical = false, magazine = false }) => ({
	pagination: environment.pagination,
	setup: environment.setup,
	ListComponent,
	list,
	cache,
	currentPath,
	showAll,
	paging,
	currentHash,
	canonical,
	magazine,
});

export default hot(module)(connect(mapState, { updatePagination })(Pagination));
